import { render, staticRenderFns } from "./RobberyVandalismAuthorKnownQuestion.vue?vue&type=template&id=ac091f92&scoped=true"
import script from "./RobberyVandalismAuthorKnownQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyVandalismAuthorKnownQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac091f92",
  null
  
)

export default component.exports